import ArrowForward from '@mui/icons-material/ArrowForward';
import Box from '@mui/material/Box';
import { useId } from 'react';

import { AppLink } from '@/components/atoms';
import { type FooterColumn } from '@/config/navigation';

import { FooterHeading } from './FooterHeading';
import { footerLinkSx } from './footerLinkSx';

/** One titled group of footer links, optionally closed by a "see more" link. */
export function FooterLinkColumn({ column }: { column: FooterColumn }) {
  const headingId = useId();
  return (
    <Box component="nav" aria-labelledby={headingId}>
      <FooterHeading id={headingId} icon={column.icon} title={column.title} />
      <Box
        component="ul"
        sx={{
          listStyle: 'none',
          p: 0,
          m: 0,
          mt: 5,
          '& > li': { pb: 3 },
        }}
      >
        {column.links.map((link) => (
          <li key={link.to + link.label}>
            <AppLink href={link.to} variant="body2" sx={footerLinkSx}>
              {link.label}
            </AppLink>
          </li>
        ))}
        {column.more && (
          <li>
            <AppLink
              href={column.more.to}
              variant="body2"
              sx={{
                ...footerLinkSx,
                color: 'primary.main',
                fontWeight: 700,
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
              }}
            >
              {column.more.label}
              <ArrowForward aria-hidden sx={{ fontSize: 16 }} />
            </AppLink>
          </li>
        )}
      </Box>
    </Box>
  );
}
